import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import React, { useState } from 'react';
import { EXPORT_TYPES, MODULES } from '../../../../../common/constants';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import UnfulfilledOrderTable from '../components/UnfulfilledOrderTable';
import { REQUEST_UNFULFILLED_ORDER_EXPORT } from '../graphql/Mutations';

const Unfulfilled = () => {
  const [form] = Form.useForm();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [exportFilter, setExportFilter] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestUnfulfilledOrderExport] = useMutation(
    REQUEST_UNFULFILLED_ORDER_EXPORT,
    {
      onError: () => {},
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestUnfulfilledOrderExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.UNFULFILLED_ORDERS,
        },
        filter: {
          search: exportFilter?.search,
          libraryIds: exportFilter?.name,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.UNFULFILLED_ORDERS}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <Card className="full-height-without-nav">
        <UnfulfilledOrderTable
          exportFilter={exportFilter}
          setExportFilter={setExportFilter}
        />
      </Card>
    </>
  );
};

export default Unfulfilled;
